import { useValidateObjectForConversion } from './useValidateObjectForConversion';

/** @deprecated temporary compatibility shim, use useValidateObjectForConversion */
export const useValidateObjectForBillingConversion = params => {
  const result = useValidateObjectForConversion(params);
  return new Set([...result.objectConversionErrors, ...result.lineItemConversionErrors]);
};